import client from './client';

export async function fetchTrackedKeywords(params) {
  const response = await client.get('/api/rankings/keywords', { params });
  return response.data;
}

export async function addKeywords(data) {
  const response = await client.post('/api/rankings/keywords', data);
  return response.data;
}

export async function deleteKeyword(id) {
  const response = await client.delete(`/api/rankings/keywords/${id}`);
  return response.data;
}

export async function batchDeleteKeywords(ids) {
  const response = await client.delete('/api/rankings/keywords/batch', { data: { ids } });
  return response.data;
}

export async function triggerRankCheck(data) {
  const response = await client.post('/api/rankings/check', data);
  return response.data;
}

export async function fetchRankHistory(keywordId, days = 30) {
  const response = await client.get(`/api/rankings/history/${keywordId}`, { params: { days } });
  return response.data;
}

export async function fetchLocationComparison(params) {
  const response = await client.get('/api/rankings/compare', { params });
  return response.data;
}

export async function fetchSerpSnapshot(keywordId) {
  const response = await client.get(`/api/rankings/serp/${keywordId}`);
  return response.data;
}

export async function searchLocations(params) {
  const response = await client.get('/api/rankings/locations', { params });
  return response.data;
}

export async function fetchRankingSummary(projectId) {
  const response = await client.get('/api/rankings/summary', { params: { project_id: projectId } });
  return response.data;
}

export async function fetchCheckStatus(projectId) {
  const response = await client.get(`/api/rankings/check-status/${projectId}`);
  return response.data;
}

export async function collectRankResults(projectId, forceClear = false) {
  const body = {};
  if (projectId) body.project_id = projectId;
  if (forceClear) body.force_clear = true;
  const response = await client.post('/api/rankings/collect', body);
  return response.data;
}

export async function clearStuckTasks() {
  const response = await client.post('/api/rankings/clear-stuck');
  return response.data;
}

export async function fetchCredentialsCheck() {
  const response = await client.get('/api/rankings/credentials-check');
  return response.data;
}
